export default "__VITE_ASSET__BRb1R3B2__"